import React from "react";
import AppBar from "../Components/AppBar";
import {useRouteMatch} from "react-router";
import {RecentImagesProvider} from "../hooks/recentimages";
import {
    CardListPageContent
} from "../../Components/TemplateList/CardListContent";
import CalendarListPageContent
    from "../../Components/TemplateList/CalendarListPageContent";
import PhotogiftListPageContent
    from "../../Components/TemplateList/PhotogiftListPageContent";

export default () => {
  const routeMatch = useRouteMatch();
  const { type, category } = routeMatch.params;

  return (
    <RecentImagesProvider>
      <AppBar disableGutters />
      {type == "cards" && <CardListPageContent category={category} />}
      {type == "calendars" && <CalendarListPageContent />}
      {type == "photogift" && (
        <PhotogiftListPageContent category={category} />
      )}
    </RecentImagesProvider>
  );
};

